import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Indicator } from './view/Indicator';
import { WrapperHorizontal } from '../../gatsby-theme-docz/components/Wrapper';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "indicator"
    }}>{`Indicator`}</h1>
    <p>{`Used to indicate some news or changes.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<Indicator />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Indicator,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Indicator mdxType="Indicator" />
    </Playground>
    <h2 {...{
      "id": "types"
    }}>{`Types`}</h2>
    <Playground __position={1} __code={'<WrapperHorizontal>\n  <Indicator type=\"default\" />\n  <Indicator type=\"primary\" />\n  <Indicator type=\"success\" />\n  <Indicator type=\"warning\" />\n  <Indicator type=\"error\" />\n  <Indicator type=\"info\" />\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Indicator,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <Indicator type="default" mdxType="Indicator" />
        <Indicator type="primary" mdxType="Indicator" />
        <Indicator type="success" mdxType="Indicator" />
        <Indicator type="warning" mdxType="Indicator" />
        <Indicator type="error" mdxType="Indicator" />
        <Indicator type="info" mdxType="Indicator" />
    </WrapperHorizontal>
    </Playground>
    <h2 {...{
      "id": "sizes"
    }}>{`Sizes`}</h2>
    <Playground __position={2} __code={'<WrapperHorizontal>\n  <Indicator size=\"small\" type=\"primary\" />\n  <Indicator size=\"medium\" type=\"primary\" />\n  <Indicator size=\"large\" type=\"primary\" />\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Indicator,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <Indicator size="small" type="primary" mdxType="Indicator" />
        <Indicator size="medium" type="primary" mdxType="Indicator" />
        <Indicator size="large" type="primary" mdxType="Indicator" />
    </WrapperHorizontal>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      